import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0070 = React.lazy(() => import('./symbols/0070_paper_role'));
const Symbol0071 = React.lazy(() => import('./symbols/0071_document_file_paper'));
const Symbol0072 = React.lazy(() => import('./symbols/0072_document_file_paper_text'));
const Symbol0073 = React.lazy(
  () => import('./symbols/0073_documents_files_paper_text_archive_copy')
);
const Symbol0074 = React.lazy(() => import('./symbols/0074_document_file_delete_remove_error'));
const Symbol0075 = React.lazy(
  () => import('./symbols/0075_document_file_paper_text_article_blog_template')
);
const Symbol0076 = React.lazy(
  () => import('./symbols/0076_document_file_zip_archive_compressed_rar')
);
const Symbol0077 = React.lazy(() => import('./symbols/0077_document_file_pdf_adobe_acrobat'));
const Symbol0078 = React.lazy(() => import('./symbols/0078_document_file_word_office_doc_text'));
const Symbol0079 = React.lazy(() => import('./symbols/0079_document_file_cloud_sync_backup'));
const Symbol0080 = React.lazy(() => import('./symbols/0080_file_code_programming_dev_binary'));
const Symbol0081 = React.lazy(() => import('./symbols/0081_video_movie_file_player'));
const Symbol0082 = React.lazy(() => import('./symbols/0082_image_photo_file'));
const Symbol0083 = React.lazy(() => import('./symbols/0083_font_file_ttf_otf_type_text'));
const Symbol0084 = React.lazy(() => import('./symbols/0084_file_preferences_settings'));
const Symbol0085 = React.lazy(() => import('./symbols/0085_file_search_find_replace_zoom_view'));
const Symbol0086 = React.lazy(() => import('./symbols/0086_import_file_load'));
const Symbol0087 = React.lazy(() => import('./symbols/0087_export_file'));
const Symbol0088 = React.lazy(() => import('./symbols/0088_download_file'));
const Symbol0089 = React.lazy(() => import('./symbols/0089_upload_file'));
const Symbol0090 = React.lazy(() => import('./symbols/0090_cv_curriculum_vitae_job_life'));
const Symbol0091 = React.lazy(() => import('./symbols/0091_file_profile_user_personal'));
const Symbol0092 = React.lazy(() => import('./symbols/0092_file_profile_user_personal'));
const Symbol0093 = React.lazy(() => import('./symbols/0093_list_bullets'));
const Symbol0094 = React.lazy(() => import('./symbols/0094_file_table'));
const Symbol0095 = React.lazy(() => import('./symbols/0095_file_protected_password_security'));
const Symbol0096 = React.lazy(() => import('./symbols/0096_file_attachment'));
const Symbol0097 = React.lazy(() => import('./symbols/0097_file_text_long'));
const Symbol0098 = React.lazy(() => import('./symbols/0098_file_document_legal_text'));
const Symbol0099 = React.lazy(() => import('./symbols/0099_legal_document_law_license'));
const Symbol0100 = React.lazy(() => import('./symbols/0100_to_do_list_reminder_done'));
const Symbol0101 = React.lazy(() => import('./symbols/0101_notes_text_notebook'));
const Symbol0102 = React.lazy(() => import('./symbols/0102_notebook_to_do_bullets_list'));
const Symbol0103 = React.lazy(() => import('./symbols/0103_box_clipboard'));
const Symbol0104 = React.lazy(() => import('./symbols/0104_load_upload_clipboard_box'));
const Symbol0105 = React.lazy(() => import('./symbols/0105_download_clipboard_box'));
const Symbol0106 = React.lazy(() => import('./symbols/0106_clipboard_box_archive_documents'));
const Symbol0107 = React.lazy(() => import('./symbols/0107_zoom_in'));
const Symbol0108 = React.lazy(() => import('./symbols/0108_zoom_out'));
const Symbol0109 = React.lazy(() => import('./symbols/0109_search_find_files_folder'));
const Symbol0110 = React.lazy(() => import('./symbols/0110_folder'));
const Symbol0111 = React.lazy(() => import('./symbols/0111_folder_files_documents'));
const Symbol0112 = React.lazy(() => import('./symbols/0112_folder_images_photos'));
const Symbol0113 = React.lazy(
  () => import('./symbols/0113_folder_password_protected_secure_private')
);
const Symbol0114 = React.lazy(() => import('./symbols/0114_folder_cloud_sync_backup'));
const Symbol0115 = React.lazy(() => import('./symbols/0115_folder_preferences_options_settings'));
const Symbol0116 = React.lazy(() => import('./symbols/0116_folder_upload'));
const Symbol0117 = React.lazy(() => import('./symbols/0117_folder_documents_revert_history'));
const Symbol0118 = React.lazy(() => import('./symbols/0118_folder_open'));
const Symbol0119 = React.lazy(() => import('./symbols/0119_folder_open_full_documents'));
const Symbol0120 = React.lazy(() => import('./symbols/0120_download_computer'));
const Symbol0121 = React.lazy(() => import('./symbols/0121_download_file'));
const Symbol0122 = React.lazy(() => import('./symbols/0122_download_file_computer_drive'));
const Symbol0123 = React.lazy(() => import('./symbols/0123_download_cloud_file_sync'));
const Symbol0124 = React.lazy(() => import('./symbols/0124_upload_cloud_file_sync_backup'));
const Symbol0125 = React.lazy(() => import('./symbols/0125_cloud_sync'));
const Symbol0126 = React.lazy(() => import('./symbols/0126_cloud_upload_backup_'));
const Symbol0127 = React.lazy(() => import('./symbols/0127_cloud_sync_error'));
const Symbol0128 = React.lazy(() => import('./symbols/0128_upload_load_share'));
const Symbol0129 = React.lazy(() => import('./symbols/0129_download'));
const Symbol0130 = React.lazy(() => import('./symbols/0130_structure_map_files'));

export interface IProps {}

const Files: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0070_paper_role" symbol={<Symbol0070 />} />
      <LazySymbol id="0071_document_file_paper" symbol={<Symbol0071 />} />
      <LazySymbol id="0072_document_file_paper_text" symbol={<Symbol0072 />} />
      <LazySymbol id="0073_documents_files_paper_text_archive_copy" symbol={<Symbol0073 />} />
      <LazySymbol id="0074_document_file_delete_remove_error" symbol={<Symbol0074 />} />
      <LazySymbol
        id="0075_document_file_paper_text_article_blog_template"
        symbol={<Symbol0075 />}
      />
      <LazySymbol id="0076_document_file_zip_archive_compressed_rar" symbol={<Symbol0076 />} />
      <LazySymbol id="0077_document_file_pdf_adobe_acrobat" symbol={<Symbol0077 />} />
      <LazySymbol id="0078_document_file_word_office_doc_text" symbol={<Symbol0078 />} />
      <LazySymbol id="0079_document_file_cloud_sync_backup" symbol={<Symbol0079 />} />
      <LazySymbol id="0080_file_code_programming_dev_binary" symbol={<Symbol0080 />} />
      <LazySymbol id="0081_video_movie_file_player" symbol={<Symbol0081 />} />
      <LazySymbol id="0082_image_photo_file" symbol={<Symbol0082 />} />
      <LazySymbol id="0083_font_file_ttf_otf_type_text" symbol={<Symbol0083 />} />
      <LazySymbol id="0084_file_preferences_settings" symbol={<Symbol0084 />} />
      <LazySymbol id="0085_file_search_find_replace_zoom_view" symbol={<Symbol0085 />} />
      <LazySymbol id="0086_import_file_load" symbol={<Symbol0086 />} />
      <LazySymbol id="0087_export_file" symbol={<Symbol0087 />} />
      <LazySymbol id="0088_download_file" symbol={<Symbol0088 />} />
      <LazySymbol id="0089_upload_file" symbol={<Symbol0089 />} />
      <LazySymbol id="0090_cv_curriculum_vitae_job_life" symbol={<Symbol0090 />} />
      <LazySymbol id="0091_file_profile_user_personal" symbol={<Symbol0091 />} />
      <LazySymbol id="0092_file_profile_user_personal" symbol={<Symbol0092 />} />
      <LazySymbol id="0093_list_bullets" symbol={<Symbol0093 />} />
      <LazySymbol id="0094_file_table" symbol={<Symbol0094 />} />
      <LazySymbol id="0095_file_protected_password_security" symbol={<Symbol0095 />} />
      <LazySymbol id="0096_file_attachment" symbol={<Symbol0096 />} />
      <LazySymbol id="0097_file_text_long" symbol={<Symbol0097 />} />
      <LazySymbol id="0098_file_document_legal_text" symbol={<Symbol0098 />} />
      <LazySymbol id="0099_legal_document_law_license" symbol={<Symbol0099 />} />
      <LazySymbol id="0100_to_do_list_reminder_done" symbol={<Symbol0100 />} />
      <LazySymbol id="0101_notes_text_notebook" symbol={<Symbol0101 />} />
      <LazySymbol id="0102_notebook_to_do_bullets_list" symbol={<Symbol0102 />} />
      <LazySymbol id="0103_box_clipboard" symbol={<Symbol0103 />} />
      <LazySymbol id="0104_load_upload_clipboard_box" symbol={<Symbol0104 />} />
      <LazySymbol id="0105_download_clipboard_box" symbol={<Symbol0105 />} />
      <LazySymbol id="0106_clipboard_box_archive_documents" symbol={<Symbol0106 />} />
      <LazySymbol id="0107_zoom_in" symbol={<Symbol0107 />} />
      <LazySymbol id="0108_zoom_out" symbol={<Symbol0108 />} />
      <LazySymbol id="0109_search_find_files_folder" symbol={<Symbol0109 />} />
      <LazySymbol id="0110_folder" symbol={<Symbol0110 />} />
      <LazySymbol id="0111_folder_files_documents" symbol={<Symbol0111 />} />
      <LazySymbol id="0112_folder_images_photos" symbol={<Symbol0112 />} />
      <LazySymbol id="0113_folder_password_protected_secure_private" symbol={<Symbol0113 />} />
      <LazySymbol id="0114_folder_cloud_sync_backup" symbol={<Symbol0114 />} />
      <LazySymbol id="0115_folder_preferences_options_settings" symbol={<Symbol0115 />} />
      <LazySymbol id="0116_folder_upload" symbol={<Symbol0116 />} />
      <LazySymbol id="0117_folder_documents_revert_history" symbol={<Symbol0117 />} />
      <LazySymbol id="0118_folder_open" symbol={<Symbol0118 />} />
      <LazySymbol id="0119_folder_open_full_documents" symbol={<Symbol0119 />} />
      <LazySymbol id="0120_download_computer" symbol={<Symbol0120 />} />
      <LazySymbol id="0121_download_file" symbol={<Symbol0121 />} />
      <LazySymbol id="0122_download_file_computer_drive" symbol={<Symbol0122 />} />
      <LazySymbol id="0123_download_cloud_file_sync" symbol={<Symbol0123 />} />
      <LazySymbol id="0124_upload_cloud_file_sync_backup" symbol={<Symbol0124 />} />
      <LazySymbol id="0125_cloud_sync" symbol={<Symbol0125 />} />
      <LazySymbol id="0126_cloud_upload_backup_" symbol={<Symbol0126 />} />
      <LazySymbol id="0127_cloud_sync_error" symbol={<Symbol0127 />} />
      <LazySymbol id="0128_upload_load_share" symbol={<Symbol0128 />} />
      <LazySymbol id="0129_download" symbol={<Symbol0129 />} />
      <LazySymbol id="0130_structure_map_files" symbol={<Symbol0130 />} />
    </>
  );
});

Files.displayName = 'Files';

export default Files;
